(() => {
  let normalizeFrame = 0;

  function eventElement(event) {
    return event.target instanceof Element ? event.target : event.target?.parentElement;
  }

  function isPayselectButton(element) {
    if (!(element instanceof Element)) return false;
    if (element.matches('#checkout, [data-gb-cart-checkout]')) return false;

    const label = (element.textContent || '').trim().toLocaleLowerCase('tr-TR');
    const className = typeof element.className === 'string' ? element.className : '';
    const marker = `${element.id || ''} ${className}`.toLowerCase();

    return (
      label.includes('havale') ||
      marker.includes('payselect') ||
      Boolean(element.closest('[id*="payselect" i], [class*="payselect" i], [data-payselect]'))
    );
  }

  function payselectButtonFromTarget(target) {
    const candidate = target?.closest?.('.cart__ctas button, .cart__ctas a, .cart__ctas [role="button"]');
    return isPayselectButton(candidate) ? candidate : null;
  }

  function forceImportantStyle(element, property, value) {
    if (!(element instanceof HTMLElement)) return;
    if (
      element.style.getPropertyValue(property) !== value ||
      element.style.getPropertyPriority(property) !== 'important'
    ) {
      element.style.setProperty(property, value, 'important');
    }
  }

  function normalizeSpacing(button) {
    const ctas = button.closest('.cart__ctas');
    if (!ctas) return;

    forceImportantStyle(ctas, 'gap', '6px');
    forceImportantStyle(ctas, 'row-gap', '6px');
    forceImportantStyle(ctas, 'column-gap', '6px');

    forceImportantStyle(button, 'margin-top', '0px');
    forceImportantStyle(button, 'margin-bottom', '0px');

    let wrapper = button.parentElement;
    while (wrapper && wrapper !== ctas) {
      wrapper.setAttribute('data-gb-payselect-wrapper', '');
      forceImportantStyle(wrapper, 'margin-top', '0px');
      forceImportantStyle(wrapper, 'margin-bottom', '0px');
      forceImportantStyle(wrapper, 'padding-top', '0px');
      forceImportantStyle(wrapper, 'padding-bottom', '0px');
      wrapper = wrapper.parentElement;
    }
  }

  function markAndEnable(button) {
    if (!(button instanceof Element)) return;

    button.setAttribute('data-gb-payselect-normalized', '');

    if ('disabled' in button && button.disabled === true) button.disabled = false;
    if (button.hasAttribute('disabled')) button.removeAttribute('disabled');
    if (button.getAttribute('aria-disabled') === 'true') button.removeAttribute('aria-disabled');
    if (button.getAttribute('tabindex') === '-1') button.removeAttribute('tabindex');

    button.classList.remove('disabled', 'is-disabled');
    normalizeSpacing(button);
  }

  function normalizeAll() {
    normalizeFrame = 0;
    document
      .querySelectorAll('.cart__ctas button, .cart__ctas a, .cart__ctas [role="button"]')
      .forEach((element) => {
        if (isPayselectButton(element)) markAndEnable(element);
      });
  }

  function scheduleNormalize() {
    if (normalizeFrame) return;
    normalizeFrame = window.requestAnimationFrame(normalizeAll);
  }

  function normalizeAfterAgreementChange() {
    queueMicrotask(normalizeAll);
    window.requestAnimationFrame(normalizeAll);
    [0, 40, 100, 220, 400].forEach((delay) => window.setTimeout(normalizeAll, delay));
  }

  function cartTermsSummary(source) {
    return source?.closest?.('.cart-summary__inner') || source?.closest?.('.cart-drawer__summary');
  }

  function requireTerms(source, event) {
    const summary = cartTermsSummary(source);
    const checkbox = summary?.querySelector('[data-gb-cart-terms]');
    if (!(checkbox instanceof HTMLInputElement) || checkbox.checked) return true;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    summary.querySelector('.gb-cart-terms')?.classList.add('is-invalid');
    const error = summary.querySelector('[data-gb-cart-terms-error]');
    if (error) error.hidden = false;
    checkbox.focus({ preventScroll: true });
    return false;
  }

  document.addEventListener(
    'click',
    (event) => {
      const target = eventElement(event);
      if (!target) return;

      const payselectButton = payselectButtonFromTarget(target);
      if (!payselectButton) return;

      markAndEnable(payselectButton);
      requireTerms(payselectButton, event);
    },
    true
  );

  document.addEventListener('change', (event) => {
    const target = eventElement(event);
    if (!target?.closest?.('[data-gb-cart-terms]')) return;
    normalizeAfterAgreementChange();
  });

  document.addEventListener('shopify:section:load', scheduleNormalize);
  document.addEventListener('cart:update', scheduleNormalize);

  function startObserver() {
    if (!document.body) return;

    const observer = new MutationObserver((mutations) => {
      const shouldNormalize = mutations.some((mutation) => {
        if (mutation.type === 'childList') {
          return Array.from(mutation.addedNodes).some(
            (node) => node instanceof Element && (node.matches('.cart__ctas, .cart__ctas *') || node.querySelector?.('.cart__ctas'))
          );
        }

        return mutation.target instanceof Element && Boolean(mutation.target.closest('.cart__ctas'));
      });

      if (shouldNormalize) scheduleNormalize();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled', 'class', 'style']
    });

    normalizeAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver, { once: true });
  } else {
    startObserver();
  }
})();
